/* eslint-disable react/no-multi-comp */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, Typography } from '@material-ui/core';

import useRouter from 'utils/useRouter';
import { NavigationListItem } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3)
  }
}));

const NavigationList = props => {
  const { pages, open, ...rest } = props;
  return (
    <List>
      {pages.reduce(
        (items, page) => reduceChildRoutes({ items, page, open, ...rest }),
        []
      )}
    </List>
  );
};

NavigationList.propTypes = {
  depth: PropTypes.number,
  handleSelect: PropTypes.func,
  open: PropTypes.bool,
  pages: PropTypes.array
};

const reduceChildRoutes = props => {
  const { router, items, page, checked, depth, parent, handleSelect, open } = props;

  if (page.children) {
    items.push(
      <NavigationListItem
        count={page.children.length}
        depth={depth}
        key={'folderID' + page.folderID}
        open={open}
        page={page}
      >
        <NavigationList
          checked={checked}
          depth={depth + 1}
          handleSelect={handleSelect}
          pages={page.children}
          parent={{ ...page, parent }}
          router={router}
          open={open}
        />
      </NavigationListItem>
    );
  } else {
    items.push(
      <NavigationListItem
        checked={checked}
        depth={depth}
        handleSelect={handleSelect(parent)}
        key={'id' + page.id}
        page={page}
      />
    );
  }

  return items;
};

const Navigation = props => {
  const { name, pages, checked, className, open, component: Component, handleSelect, ...rest } = props;


  const classes = useStyles();
  const router = useRouter();

  return (
    <Component
      {...rest}
      className={clsx(classes.root, className)}
    >
      {name && <Typography variant="overline">{name}</Typography>}
      <NavigationList
        open={open}
        checked={checked}
        depth={0}
        handleSelect={handleSelect}
        pages={pages}
        parent={null}
        router={router}
      />
    </Component>
  );
};

Navigation.propTypes = {
  checked: PropTypes.array,
  className: PropTypes.string,
  component: PropTypes.any,
  handleSelect: PropTypes.func,
  name: PropTypes.string,
  open: PropTypes.bool,
  pages: PropTypes.array.isRequired
};

Navigation.defaultProps = {
  component: 'nav'
};

export default Navigation;
